import React, { Component } from 'react';
import Faq from 'react-faq-component';
import "./PageFAQ.css";

const data = {
  title: "FAQ",
  rows: [
    {
      title: "Comment réserver mon séjour?",
      content: "Vous sélectionnez la période pendant laquelle vous souhaitez séjourner dans notre villa sur le calendrier et vous nous laissez un message avec vos coordonnées. Nous vous confirmerons les disponibilités et tarifs. Si vous souhaitez poursuivre la réservation nous vous adressons un contrat de location. La réservation est confirmée à la signature du contrat et au règlement des arrhes."
    },
    {
      title: "Quelle est la durée minimale d'un séjour?",
      content: "Les locations se font habituellement à la semaine du samedi au samedi. Il est possible d\'effectuer des séjours de 6 nuitées hors période de vacances scolaires."
    },
    {
      title: "Comment se passe la remise du dépôt de garantie?",
      content: "Vous nous remettez le dépôt de garantie par chèque lors de votre accueil à la villa. Celui-ci n'est pas encaissé et vous est restitué à l\'issue de votre séjour en l\'absence de dommages. Nous acceptons aussi les remises par virement bancaire, auquel cas la restitution sera également effectuée par virement bancaire."
    },
    {
      title: "Les arrivées et départs sont-ils autonomes?",
      content: "Les arrivées et départs ne sont pas autonomes. Vous serez accueillis à la villa par notre conciergerie partenaire qui vous remettra les clés et vous donnera toutes les informations utiles. La conciergerie vous assistera également lors de votre départ "
    },
    {
        title: "Quels sont les horaires d\'arrivée et de départ?",
        content: "Les arrivées se font entre 16h et 20h et les départs entre 8h et 10h. Notre conciergerie partenaire pourra être amenée à vous facturer des frais supplémentaires de 30€ en cas d\'arrivée tardive ou de départ anticipé."
      }]
}

const styles = {
  
}

class PageFAQ extends React.Component {

  render() {
    return (
        <div>
        <Faq
          data={data}
          styles={styles}/>
      </div>
    );
  }
}

  
  export default PageFAQ;


// WEBPACK FOOTER //
// ./src/PageFAQ.js